export function IronDivider({ className = "", light = false }) {
  const c = light ? "#D4AF37" : "#C59B27";
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
      <span className="h-px flex-1" style={{ background: `linear-gradient(to right, transparent, ${c}66)` }} />
      <svg width="34" height="14" viewBox="0 0 34 14" fill="none" stroke={c} strokeWidth="1">
        <path d="M17 1c3 3 3 9 0 12-3-3-3-9 0-12z" />
        <path d="M1 7c4-4 9-4 12 0-3 4-8 4-12 0zM33 7c-4-4-9-4-12 0 3 4 8 4 12 0z" />
      </svg>
      <span className="h-px flex-1" style={{ background: `linear-gradient(to left, transparent, ${c}66)` }} />
    </div>
  );
}

export function SectionHeader({ eyebrow, title, children, actions, testId }) {
  return (
    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-8 fade-up" data-testid={testId}>
      <div className="max-w-3xl">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#0F2E23] mt-2 leading-tight">{title}</h1>
        {children && <p className="text-slate-600 mt-3 text-sm sm:text-base leading-relaxed">{children}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ title, eyebrow, children, className = "", testId, right }) {
  return (
    <section className={`paper rounded-lg p-5 sm:p-7 ${className}`} data-testid={testId}>
      {(title || eyebrow) && (
        <div className="flex items-start justify-between gap-3 mb-5">
          <div>
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && <h2 className="font-display text-2xl font-semibold text-[#0F2E23] mt-1">{title}</h2>}
          </div>
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function Stat({ label, value, sub, testId, dark = false }) {
  return (
    <div className={`rounded-lg p-4 sm:p-5 border ${dark ? "bg-[#0F2E23] border-[#164032] text-[#F9F6F0]" : "bg-white border-[#E2DCD2]"}`} data-testid={testId}>
      <p className={`text-[0.68rem] uppercase tracking-[0.18em] font-semibold ${dark ? "text-[#D4AF37]" : "text-[#3E5C4E]"}`}>{label}</p>
      <p className={`font-mono-num text-xl sm:text-2xl font-semibold mt-2 break-words ${dark ? "text-[#F9F6F0]" : "text-[#0F2E23]"}`}>{value}</p>
      {sub && <p className={`text-xs mt-1 ${dark ? "text-[#F9F6F0]/60" : "text-slate-500"}`}>{sub}</p>}
    </div>
  );
}

export const btn = {
  primary: "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md bg-[#0F2E23] text-[#F9F6F0] text-sm font-semibold hover:bg-[#164032] disabled:opacity-50 transition-colors",
  gold: "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md bg-[#C59B27] text-[#0F2E23] text-sm font-semibold hover:bg-[#D4AF37] disabled:opacity-50 transition-colors",
  ghost: "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md border border-[#E2DCD2] bg-white text-[#0F2E23] text-sm font-medium hover:border-[#C59B27] hover:bg-[#F9F6F0] disabled:opacity-50 transition-colors",
  danger: "inline-flex items-center justify-center gap-2 h-9 px-3 rounded-md border border-red-200 text-red-700 text-sm hover:bg-red-50 transition-colors",
};

export const inputCls = "w-full h-10 rounded-md border border-[#E2DCD2] bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#C59B27]/40 focus:border-[#C59B27]";
